/* eslint-env browser */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Flex } from 'reflexbox';
import {
  Overlay,
  Panel,
} from 'rebass';

import actions from 'frontend/state/actions';
import { selectors } from 'frontend/state/reducers/site';

import TalentTree from 'frontend/components/Simbot/TalentTree';
import {
  TinyButton,
} from 'frontend/components';

const TalentTreeOverlay = ({ talentTreeOverlay, onDismiss }) => {
  if (!talentTreeOverlay || !talentTreeOverlay.talents) {
    return null;
  }

  const escFn = React.useCallback(e => {
    if (e.key === 'Escape') {
      onDismiss();
    }
  }, []);

  React.useEffect(() => {
    document.addEventListener('keydown', escFn, false);

    return () => {
      document.removeEventListener('keydown', escFn, false);
    };
  }, []);

  return (
    <Overlay
      open
      style={{ overflow: 'none' }}
      onDismiss={onDismiss}
    >
      <Panel theme="warning">
        <Flex justify="flex-end">
          <TinyButton onClick={onDismiss}>
            Close
          </TinyButton>
        </Flex>
        <TalentTree
          specId={talentTreeOverlay.specId}
          level={talentTreeOverlay.level}
          talents={talentTreeOverlay.talents}
          width={900}
          readOnly
        />
      </Panel>
    </Overlay>
  );
};

TalentTreeOverlay.propTypes = {
  talentTreeOverlay: PropTypes.shape({
    talents: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    specId: PropTypes.number,
    level: PropTypes.number,
  }),
  onDismiss: PropTypes.func.isRequired,
};

TalentTreeOverlay.defaultProps = {
  talentTreeOverlay: null,
};

const mapStateToProps = state => ({
  talentTreeOverlay: selectors.talentTreeOverlay(state),
});

const mapDispatchToProps = {
  onDismiss: () => actions.clearTalentTreeOverlay(),
};

export default connect(mapStateToProps, mapDispatchToProps)(TalentTreeOverlay);
